export default __webpack_public_path__ + "static/media/feature4_5.61f724eb.png";